import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { useAccounts } from '../lib/useAccounts';
import { reorderCandidates } from '../lib/salesData';

export default function Reorders() {
  const { demo } = useAuth();
  const { data, loading } = useAccounts(demo);
  const nav = useNavigate();
  const list = useMemo(() => reorderCandidates(data?.accounts ?? []), [data]);

  if (loading) return <div className="loading"><div className="spinner" /> Analyzing reorder signals…</div>;
  const overdue = list.filter((r) => r.window === 'Overdue').length;

  return (
    <>
      <div className="page-head">
        <div><div className="page-title">Reorder Intelligence</div><div className="page-sub">Clients who may need to reorder based on past SKUs and order history.</div></div>
        <span className="live-flag">{list.length} signals</span>
      </div>

      <div className="grid cols-3" style={{ marginBottom: 16 }}>
        <div className="metric-card"><div className="metric-label">Reorder Signals</div><div className="metric-value" style={{ color: 'var(--ac)' }}>{list.length}</div><div className="metric-note">clients flagged</div></div>
        <div className="metric-card"><div className="metric-label">Overdue</div><div className="metric-value" style={{ color: 'var(--rd)' }}>{overdue}</div><div className="metric-note">act now</div></div>
        <div className="metric-card"><div className="metric-label">High Confidence</div><div className="metric-value" style={{ color: 'var(--gn)' }}>{list.filter((r) => r.confidence >= 80).length}</div><div className="metric-note">≥ 80%</div></div>
      </div>

      <div className="table-wrap"><table>
        <thead><tr><th>Client</th><th>SKU</th><th>Product</th><th>Last order</th><th>Window</th><th>Confidence</th><th></th></tr></thead>
        <tbody>
          {list.map((r) => (
            <tr key={r.clientId} onClick={() => nav(`/client?id=${encodeURIComponent(r.clientId)}`)}>
              <td><strong>{r.clientName}</strong></td>
              <td className="mono" style={{ background: 'none', border: 'none', padding: 0 }}>{r.sku.sku}</td>
              <td style={{ color: 'var(--tx2)' }}>{r.sku.product} · {r.reorders}× prior</td>
              <td>{r.sku.lastOrder}</td>
              <td><span className={`tag ${r.window === 'Overdue' ? 'pr-critical' : r.window === 'This month' ? 'pr-rush' : 'pr-standard'}`}>{r.window}</span></td>
              <td><div className="conf-bar"><span style={{ width: `${r.confidence}%`, background: r.confidence >= 80 ? 'var(--gn)' : r.confidence >= 60 ? 'var(--or)' : 'var(--tx3)' }} /></div><span className="conf-num">{r.confidence}%</span></td>
              <td><button className="btn small" onClick={(e) => { e.stopPropagation(); nav('/quote-engine'); }}>Quote →</button></td>
            </tr>
          ))}
          {list.length === 0 && <tr><td colSpan={7}><div className="empty">No reorder signals yet.</div></td></tr>}
        </tbody>
      </table></div>
    </>
  );
}
